import { render, staticRenderFns } from "./TableSelector.vue?vue&type=template&id=5e145492"
import script from "./TableSelector.vue?vue&type=script&lang=js"
export * from "./TableSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports